export const acknowledgeAllAlertTriggersAction =
  'acknowledgeAllAlertTriggersAction';
export const resolveAllAlertTriggersAction = 'resolveAllAlertTriggersAction';
